import loadCombatantSRImages from "./loadCombatantSRImages";
//---------------------------
// load combatants SR images
//---------------------------
export default function loadCombatantsSRImages(combatants) {
  // console.log("-------------------")
  // console.log("IN loadCombatantsSRImages")
  //----------------------
  // loop thru combatants
  //----------------------
  for (let i = 0; i < combatants.length; i++) {
    combatants[i] = loadCombatantSRImages(combatants[i]);
  }
  return combatants;
}
